module.exports = __webpack_public_path__ + "027c2e07d3ac06c674204c37f9a57f2a.png";